import React from 'react'

const MenuContext = React.createContext(true)

export default MenuContext
